export default {
  currencySymbol: 'C$'
}
